module.exports = __webpack_public_path__ + "img/c-clients-1.jpg";